/**
 * SoKeto — ProveSource + sticky ATC su browser senza :has() affidabile (fallback).
 * La logica principale è in soketo-ux.css (body.modal-show, cart-template, :has).
 * Qui solo: mobile + sticky bar visibile quando CSS.supports('selector(:has(*)')') è false.
 */
(function () {
  var mq = window.matchMedia('(max-width: 767.98px)');
  var root = document.documentElement;
  var FLAG = 'soketo-provesrc-sticky-fallback';

  function hasNativeHas() {
    try {
      return typeof CSS !== 'undefined' && CSS.supports && CSS.supports('selector(:has(body))');
    } catch (e) {
      return false;
    }
  }

  function stickyVisible() {
    return !!document.querySelector(
      '.sticky-atc-bar.sticky-atc-bar--show, sticky-atc-bar-minimalist.sticky-atc-bar--show'
    );
  }

  var ticking = false;
  function update() {
    if (hasNativeHas()) {
      root.classList.remove(FLAG);
      return;
    }
    if (!mq.matches) {
      root.classList.remove(FLAG);
      return;
    }
    root.classList.toggle(FLAG, stickyVisible());
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  function watchStickyNodes() {
    document.querySelectorAll('.sticky-atc-bar, sticky-atc-bar-minimalist').forEach(function (el) {
      var mo = new MutationObserver(schedule);
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() {
    if (hasNativeHas()) return;
    update();
    mq.addEventListener('change', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    watchStickyNodes();
    document.addEventListener('shopify:section:load', function () {
      watchStickyNodes();
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
